// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Em6Q","newExpiryDate":"styles_newExpiryDate__1qNv-","footer":"styles_footer__2WoH7"};